import type { IQuery } from "@citrine/client";
import ClientBase from "@citrine/client";

import type { DesignSpaceSummary } from "./design-space-summary";

interface DesignSpaceSummaryQuery extends IQuery {
  page?: number;
  per_page?: number;
  archived?: boolean;
  sort_by?: string;
  name?: string;
  dk?: string[];
}

export class DesignSpaceSummaryClient extends ClientBase<
  DesignSpaceSummary,
  string,
  DesignSpaceSummaryQuery
> {
  create: never;
  delete: never;
  patch: never;
  update: never;

  useCreate: never;
  useDelete: never;
  usePatch: never;
  useUpdate: never;

  protected constructor(protected readonly projectId: string) {
    super({
      endpoint: `/api/v4/projects/${projectId}/design-space-summaries`,
      findField: "response",
      defaultQuery: {
        page: 1,
        per_page: 20,
        archived: undefined,
        sort_by: undefined,
        name: undefined,
        dk: undefined,
      },
    });
  }

  static getInstance(projectId: string) {
    return new this(projectId);
  }
}
